import React from 'react';
import { format, parseISO } from 'date-fns';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const ConsumptionChart = ({ prepareChartData,chartConfig,height}) => {  
  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length || 
        !payload.some(p => p.value > 0)) {
      return null;
    }
    return (
      <div style={{ 
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '8px',
        zIndex: 9999,
        position: 'relative',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ marginBottom: '4px', fontSize: '11px', color: '#666', borderBottom:"1px solid #ccc", paddingBottom:"2px" }}>
          {format(new Date(label), 'MMM dd yyyy')}
        </div>
        {payload.map((entry, index) => (
          entry.value > 0 && (
            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <div style={{ 
                width: '12px', 
                height: '12px', 
                backgroundColor: entry.color,
                borderRadius: '2px'
              }} />
              <span>{entry.name}: {entry.value}</span>
            </div>
          )
        ))}
      </div>
    );
  };

  const chartData = prepareChartData();
  return (
    
    <ResponsiveContainer width="100%" height={height} >
      <BarChart
        data={chartData}
        margin={{
          top: 30,
          right: 0,
          bottom: 0,
          left: 0
        }}
        barCategoryGap="5%"
        barGap={2}
      >
        <CartesianGrid 
          strokeDasharray="0 0"  // Makes lines solid instead of dotted
          horizontal={true}      // Show horizontal lines
          vertical={false}       // Hide vertical lines
        />
        <XAxis 
          dataKey="date"
          angle={0}
          height={60}
          interval={0}
          axisLine={true} 
          tickLine={false}
          tick={{ 
            fontSize: 9
          }}
          tickFormatter={(value) => {
            const firstDate = chartData[0] && chartData[0].date;
            const lastDate = chartData[chartData.length - 1] && chartData[chartData.length - 1].date;
            const dateObj = typeof value === 'string' ? parseISO(value) : new Date(value);
            if (value === firstDate || value === lastDate) {
            return format(dateObj, 'MMM d');
            }
            return "";
          }}
        />
       <YAxis 
          axisLine={false}
          tickLine={false}
          tick={{ 
            fontSize: 9,
            fill: '#666'
          }}
        />
        <Tooltip 
          cursor={false}
          content={<CustomTooltip />}
        />
        {chartConfig.map((config) => (
        <Bar
          key={config.dataKey}
          dataKey={config.dataKey}
          name={config.name}
          stackId="a"
          fill={config.fill}
          barSize={20}
        />
      ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ConsumptionChart;